var renutils = {};

/**
 * A wrapper for console.log in case it isn't available (older IE).
 */
(function () {
	var nop = function () {};

	if (typeof window.console == "undefined" || !window.console) {
		window.console = {
			log:nop, info:nop, warn:nop, debug:nop, error:nop
		};
	}

	if (typeof console == "undefined" || !console) {
		console = window.console;
	}

    renutils.console = console;
}());

// In IE, the console might be undefined if devtools isn't open. In Edge, the _functions_ within the console object
// might be lost if devtools is _closed_. Handle both cases here...
renutils.console = {
	log: function() {
        if (console != null && console.log != null)
            return console.log.apply(console, arguments);
        else
        	return function() {};
    },

    debug: function() {
        if (console != null && console.debug != null)
            return console.debug.apply(console, arguments);
        else
            return function() {};
    },

    info: function() {
        if (console != null && console.info != null)
            return console.info.apply(console, arguments);
        else
            return function() {};
    },

    warn: function() {
        if (console != null && console.warn != null)
            return console.warn.apply(console, arguments);
        else
            return function() {};
    },

    error: function() {
        if (console != null && console.error != null)
            return console.error.apply(console, arguments);
        else
            return function() {};
    }
};

renutils.createUniqueID = function(screenname) {
	renutils.uniqueId = renutils.hashCode(screenname);
	return renutils.uniqueId;
}

/**
 * JS Hashcode implementation similar to Java
 */
renutils.hashCode = function(str2hash) {
 	var hash = 0, i, chr;

	if (str2hash.length === 0) return hash;

	for (i = 0; i < str2hash.length; i++) {
 		chr   = str2hash.charCodeAt(i);
 		hash  = ((hash << 5) - hash) + chr;
 		hash |= 0; // Convert to 32bit integer
	}

	return hash;
}

renutils.getQueryParam = function(paramName, url) {
    if (!url) {
		url = window.location.href;
	}

    var paramName = paramName.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + paramName + "(=([^&#]*)|&|#|$)");
    var results = regex.exec(url);

    if (!results)
		return null;
    else if (!results[2])
		return '';
	else
		return decodeURIComponent(results[2].replace(/\+/g, " "));
}

renutils.updateQueryParam = function(paramName, paramValue, url) {
	if (!url) {
		url = window.location.href;
	}

	var paramName = paramName.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + paramName + "(=([^&#]*))");
	var results = regex.exec(url);

	if (!results)
		return renutils.appendQueryParam(url, renutils.formatQueryParam(paramName, paramValue));
	else if (!results[2] && !paramValue)
		return url;
	else
		return url.substring(0, results.index + 1) +
			renutils.formatQueryParam(paramName, paramValue) +
			url.substring(results.index + results[0].length);
}

renutils.appendQueryParam = function(url, paramNameOrParamWithValue, paramValue) {
	let paramQuery = renutils.formatQueryParam(paramNameOrParamWithValue, paramValue);
	return url + (url.indexOf("?") >= 0 ? "&" : "?") + paramQuery;
}

renutils.formatQueryParam = function(paramNameOrParamWithValue, paramValue) {
	if (!paramValue)
		return paramNameOrParamWithValue;
	else
		return paramNameOrParamWithValue + "=" + paramValue;
}

renutils.removeQueryParam = function(paramName, url) {
	if (!url) {
		url = window.location.href;
	}

	var paramName = paramName.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + paramName + "(=([^&#]*))");
	var results = regex.exec(url);

	if (!results) {
		return url;
	}
	else {
		if (results.index + results[0].length >= url.length || url.charAt(results.index + results[0].length) != '&')
			return url.substring(0, results.index) + url.substring(results.index + results[0].length);
		else
			return url.substring(0, results.index + 1) + url.substring(results.index + results[0].length);
	}
}

renutils.escapeHtml = function(str) {
    return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

renutils.forEachElementByClass = function(classname, func){
	var elems = document.getElementsByClassName(classname);
	if (elems) {
		for(var i = 0; i < elems.length; i++) {
			func(elems[i]);
		}
	}
}

renutils.removeElementByClass = function(classname){
	renutils.forEachElementByClass(classname, elem => elem.remove());
}

/**
 * Convert
 * a) a relative URL (e.g. "/test") to an URL with the same scheme, domain & port as the current request (e.g. "http://www.ren.no/test").
 * b) a schemeless URL (e.g. "//www.ren.no/test") to an URL with the same scheme as the current request (e.g. "http://www.ren.no/test").
 */
renutils.toLocalUrl = function(url) {
	if (url.indexOf("//") == 0) {
		var i = window.location.href.indexOf("//");
		if (i < 0)
			return url;

		return window.location.href.substring(0, i) + url;
	}
	else if (url.indexOf("/") == 0) {
		var i = window.location.href.indexOf("//");
		if (i < 0)
			return url;

		i = window.location.href.indexOf("/", i + 2);
		if (i < 0)
			return url;

		return window.location.href.substring(0, i) + url;
	}
	else
		return url;
}

/**
 * A browser-agnostic means for creating a CORS request. Courtesy of Nicholas Zakas,
 * http://www.nczonline.net/blog/2010/05/25/cross-domain-ajax-with-cross-origin-resource-sharing/.
 */
renutils.createCORSRequest = function(method, url, timeout) {
	if (timeout == null) {
        timeout = 5000;
	}

	var xhr = new XMLHttpRequest();

    // Check if the XMLHttpRequest object has a "withCredentials" property.
    // "withCredentials" only exists on XMLHTTPRequest2 objects.
	if ("withCredentials" in xhr) {
		xhr.open(method, url, true);
        xhr.timeout = timeout; // Note: Timeout must be set _after_ open (to avoid InvalidStateError in IE)
	}
    // Otherwise, check if XDomainRequest.
    // XDomainRequest only exists in IE, and is IE's way of making CORS requests.
    else if (typeof XDomainRequest != "undefined") {
		xhr = new XDomainRequest();
		xhr.open(method, url);
        xhr.timeout = timeout; // Note: Timeout must be set _after_ open (to avoid InvalidStateError in IE)
	}
	else {
		// Otherwise, CORS is not supported by the browser.
		xhr = null;
	}

	return xhr;
}

renutils.getCookie = function(name) {
	var prefix = name + "=";
	var tokens = document.cookie.split(';');

	for(var i = 0; i < tokens.length; i++) {
		var token = tokens[i].trim();

		if (token.indexOf(prefix) == 0) {
			var tokenValue = token.substring(prefix.length, token.length);
			return decodeURI(tokenValue);
		}
	}

	return null;
}

renutils.createCookie = function(name, value, days, path) {
	if (!path) {
		path = "/";
	}

	var expires;

	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = "; expires=" + date.toGMTString();
	} else {
		expires = "";
	}

	document.cookie = encodeURI(name) + "=" + encodeURI(value) + expires + "; path=" + path;
}

renutils.deleteCookie = function(name, path) {
	if (!path) {
		path = "/";
	}

	document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=" + path;
}

renutils.sendRenAjaxJsonGet = function(config) {
	var request = new XMLHttpRequest();
	request.open("GET", config.url, true);

	request.withCredentials = true;
	request.timeout = config.timeout;

	if (renutils.sso.keycloak && renutils.sso.keycloak.token) {
		request.setRequestHeader("Authorization", "bearer " + renutils.sso.keycloak.token);
	}

	request.onload = function () {
		if (this.status >= 200 && this.status < 400) {
			if (config.callback) {
				config.callback(JSON.parse(this.response));
			}
		}
	};

	request.send();
}

/**
 * Creates a launch menu for the user and appends to <span class="application-launch"/>
 */
renutils.createLaunchMenu = function(_userName, _userLaunchUrl, customLaunchDropdownToggleClass, customDropdownMenuClass, defLogoutUrl, keyPrefix, locale) {
	var logoutUrl = defLogoutUrl ||
		'https://' + document.domain + '/auth/realms/' + document.domain + '/protocol/openid-connect/logout?redirect_uri=https://' + document.domain + '/logg-ut?confirm=true';
	renutils.logoutUrl = logoutUrl;

    if (!keyPrefix) {
        keyPrefix = "";
	}

    if (locale) {
    	keyPrefix += locale + "-";
	}

    renutils.launchMenuKeyPrefix = keyPrefix;

    // Create a base menu with button and sign-out link
	var basemenuContent = renutils.generateBaseLaunchMenuContentHtml(logoutUrl, locale);
	var appLaunchElems = document.getElementsByClassName("application-launch");
	var basemenu = (appLaunchElems && appLaunchElems.length > 0 && appLaunchElems[0].tagName === "UL") ?
		basemenuContent : renutils.generateBaseLaunchMenuHtml(basemenuContent, customLaunchDropdownToggleClass, customDropdownMenuClass);

	renutils.forEachElementByClass("application-launch", elem => {
		elem.insertAdjacentHTML("beforeend", basemenu);
		elem.classList.add("launch-group");
		elem.classList.remove("application-launch"); // Prevent the menu from being applied twice
	});

	var launchMenuTools = sessionStorage.getItem(keyPrefix + "launchMenuTools");
	var launchMenuToolsChangeCounter = sessionStorage.getItem(keyPrefix + "launchMenuToolsChangeCounter");
	var renUserChangeCounter = renutils.getCookie("RENUSER_CHANGE_COUNTER");
	var fetch = false;

	if (!launchMenuTools || !launchMenuToolsChangeCounter) {
        renutils.console.log("Launch menu not found - will fetch it from the server");
		fetch = true;
	}
	else if (renUserChangeCounter && (renUserChangeCounter !== launchMenuToolsChangeCounter)) {
        renutils.console.log("Detected outdated launch menu - will re-fetch it from the server");
		fetch = true;
	}

	if (fetch && _userLaunchUrl != null && _userName != null) {
		renutils.sendRenAjaxJsonGet({
			timeout: 5000,
			url: _userLaunchUrl + "/" + _userName + (locale ? "?ren-locale=" + locale : ""),
			callback: function (json) { renutils.buildLaunchMenu(json); }
		});
	} else {
		renutils.setLaunchMenuTools(launchMenuTools);
	}
}

renutils.generateBaseLaunchMenuHtml = function(menuContent, customLaunchDropdownToggleClass, customDropdownMenuClass) {
	return '<span class="launch-dropdown-toggle ' + customLaunchDropdownToggleClass +
        '" data-toggle="dropdown" aria-expanded="false" onclick="renutils.removeElementByClass(\'launchnotification\');"> <span class="fa fa-reorder"></span></span>' +
        '<ul class="dropdown-menu launch-dropdown-menu ' + customDropdownMenuClass +'" role="menu">' +

        menuContent +

        '</ul>';
}

renutils.generateBaseLaunchMenuContentHtml = function(logoutUrl, locale) {
	return '<span class="fetched-webapplications"/>' + // Placeholder for urls from the database

        // Sign-out link + , will be replaced if customer system is able to serve a full menu
        '<li class="dropdown-menu-item base-launch-menu"><span style="color: #757575; text-align: center; display: block;">' +
				(locale === 'en' ? 'No menu available' : 'Ingen meny tilgjengelig') +
		'</span><hr/></li>' +
        '<li class="divider base-launch-menu">' +
        '<li class="dropdown-menu-item base-launch-menu"><a href="' + logoutUrl + '">' +
		  renutils.generateLaunchMenuIconHtml({
			  iconClass: 'fa fa-sign-out',
			  materialIcon: 'power_settings_new'
		  }) +
		(locale === 'en' ? 'Log out' : 'Logg ut') +
		'</a></li>';
}

renutils.generateLaunchMenuIconHtml = function(obj) {
	if (renutils.useMaterialIcons)
		return '<i class="material-icons">' + (obj.materialIcon == null ? "" : obj.materialIcon) + '</i>';
	else
		return '<span class="'+ (obj.iconClass == null ? '' : obj.iconClass) + '"> </span>';
}

renutils.generateLaunchMenuHtml = function(data) {
	if (renutils.sso.keycloak && renutils.sso.keycloak.token) {
		renutils.console.log("Building launch menu: jwt token found");

		const externalSource = this.getCustomerExternalSourceFromToken(renutils.sso.keycloak.token);
		if (externalSource === "STRIPE" || externalSource === "ENERGIFORETAGEN") {
			renutils.console.log("Building launch menu: external source found");

			const signOutItem = data.find(item => item.iconClass && item.iconClass.includes('fa-sign-out'));
			if (signOutItem) {
				const logoutUrl = renutils.logoutUrl ? renutils.logoutUrl : signOutItem.url;
				return '<li role="menuitem" class="dropdown-menu-item"><a onclick="renutils.sso.showingLoggedOutFlag = true; renutils.explicitLogout(function() { window.location = \'' + logoutUrl + '\'}); return false;" href="' + logoutUrl +
					'">'+ renutils.generateLaunchMenuIconHtml(signOutItem) + signOutItem.name + '</a></li>';
			} else {
				renutils.console.log("Sign out item not found in the data");
			}
		}
	}

    var tools = '';

    for (var i = 0; i < data.length; i++) {
		var obj = data[i];

    	// A divider?
        if (obj.name == '-') {
            tools += '<li role="menuitem" class="divider">';
        }
        // The logout entry?
        else if (obj.iconClass != null && obj.iconClass.indexOf('fa-sign-out') > -1) {
            var logoutUrl = renutils.logoutUrl ? renutils.logoutUrl : obj.url;
            tools += '<li role="menuitem" class="dropdown-menu-item"><a onclick="renutils.sso.showingLoggedOutFlag = true; renutils.explicitLogout(function() { window.location = \'' + logoutUrl + '\'}); return false;" href="' + logoutUrl +
                '">'+ renutils.generateLaunchMenuIconHtml(obj) + obj.name + '</a></li>';
        }
        // Ok, this is a normal entry.
        else {
            tools += '<li role="menuitem" class="dropdown-menu-item"><a href="' + obj.url + '">' + renutils.generateLaunchMenuIconHtml(obj) + obj.name + '</a></li>';
        }
    }

    return tools;
}

renutils.buildLaunchMenu = function(data) {
    renutils.console.log("Building launch menu");

	var tools = renutils.generateLaunchMenuHtml(data);
	var renUserChangeCounter = renutils.getCookie("RENUSER_CHANGE_COUNTER");

	sessionStorage.setItem(renutils.launchMenuKeyPrefix + "launchMenuTools", tools);
	sessionStorage.setItem(renutils.launchMenuKeyPrefix + "launchMenuToolsChangeCounter", renUserChangeCounter ? renUserChangeCounter : -1);
	renutils.setLaunchMenuTools(tools);
}

renutils.clearLaunchMenuTools = function() {
	for (const key in sessionStorage) {
		if (key != null && (key.endsWith("launchMenuTools") || key.endsWith("launchMenuToolsChangeCounter") || key.endsWith("launchMenuComplete"))) {
			sessionStorage.removeItem(key);
		}
	}
}

renutils.clearSession = function() {
	renutils.clearLaunchMenuTools();
}

renutils.setLaunchMenuTools = function(tools) {
	if (tools == null)
		return;

	renutils.forEachElementByClass("fetched-webapplications", elem =>
		elem.outerHTML = tools)
	renutils.removeElementByClass("base-launch-menu");

	var launchGroupElems = document.getElementsByClassName("launch-group");
	sessionStorage.setItem(renutils.launchMenuKeyPrefix + "launchMenuComplete",
		(launchGroupElems && launchGroupElems.length > 0) ? launchGroupElems.outerHTML : null);
}

renutils.notificationPopup = {};

/**
 * Creates a popup for displaying information about the launch menu
 * @param _username The user for which the popup should be generated
 * @param _userLaunchUrl The url to rest api for serving if the notification should be displayed
 * @param _resource	For which resource the notification should be displayed
 * @param _username Custom styling classname for dropdown toggle
 */
renutils.createNotificationPopup = function(_userName, _url, _resource, _customClass) {
	renutils.notificationPopup[_resource] = {};
	renutils.notificationPopup[_resource].userName = _userName;
	renutils.notificationPopup[_resource].additionalClass = _customClass;
	renutils.notificationPopup[_resource].url = _url;

	var notificationChangeCounter = sessionStorage.getItem("notificationChangeCounter_" + _resource);
	var renNotificationChangeCounter = renutils.getCookie("RENNOTIFICATION_CHANGE_COUNTER");
	var fetch = false;

	if (!notificationChangeCounter) {
        renutils.console.log("Notification popup '" + _resource + "' not found - will fetch it from the server");
		fetch = true;
	}
	else if (renNotificationChangeCounter && (renNotificationChangeCounter != notificationChangeCounter)) {
        renutils.console.log("Detected outdated notification popup '" + _resource + "' - will re-fetch it from the server");
		fetch = true;
	}

	if (fetch && _url != null && _userName != null && _resource != null) {
		renutils.sendRenAjaxJsonGet({
			timeout: 5000,
			url: _url + '/' + _userName + '/' + _resource,
			callback: function (json) { renutils.buildNotificationPopup(json); }
		});
	}
}

renutils.buildNotificationPopup = function(data) {
	var notificationName = data.notificationName;

	if (renutils.notificationPopup[notificationName] && data.date == null) {
		// Create and show a dialog.
		var script = "javascript: renutils.removeElementByClass('launchnotification');";

		renutils.forEachElementByClass("launch-group", elem =>
			elem.insertAdjacentHTML("beforeend",
				'<div class="launchnotification" style="position: absolute; z-index: 999999;">' +
				'<div class="arrow_box ' + renutils.notificationPopup[notificationName].additionalClass + '">' +
				'<strong><a href="' + script + '" style="float: right; position: relative; top: -14px; right: -8px;">x</a></strong>' +
				'Her finner du snarveier til REN\'s ulike tjenester.' +
				'</div>' +
				'</div>'));
	}

	var renNotificationChangeCounter = renutils.getCookie("RENNOTIFICATION_CHANGE_COUNTER");
	sessionStorage.setItem("notificationChangeCounter_" + notificationName, renNotificationChangeCounter ? renNotificationChangeCounter : -1);
}

// Global constants and variables for functions initSsoXxx and registerXxxAutoRefresh.
renutils.sso = {
	POLL_SSO_PERIOD: 2 * 60 * 1000,
	EAGER_POLL_SSO_MIN_INACTIVITY_DURATION: 20 * 60 * 1000,

	casLoginStamp: null, // TODO: Keep the old name until CAS is phased out (its JSPs access this value...).
	ssoLoginStampName: "cas-login-stamp", // TODO: Keep the old value until CAS is phased out.
	ssoTimer: null,
	prevPollSsoTime: null,
	lastActivityTime: new Date().getTime(),
	showingLoggedOutFlag: false,

	// DEPRECATED?
	casLogoutUrl: null,
	// DEPRECATED?
	casLoginUrl: null,
	// DEPRECATED?
	casKeepAliveServiceUrl: null,

	// Configuration that users can provide via the argument to startSsoPolling(...):
	checkSsoFunc: null,
	webappCheckSessionUrl: null,
	webappLogoutFunc: null,
	webappLogoutUrl: null,
	webappJsessionIdPath: null,
	keycloak: null
}

renutils.startSsoPolling = function(config) {
    renutils.console.log("Starting SSO polling");

	if (config) {
		renutils.sso.checkSsoFunc = config.checkSsoFunc;
		renutils.sso.webappCheckSessionUrl = config.webappCheckSessionUrl;
		renutils.sso.webappLogoutFunc = config.webappLogoutFunc;
		renutils.sso.webappLogoutUrl = config.webappLogoutUrl;
		renutils.sso.webappJsessionIdPath = config.webappJsessionIdPath;
		renutils.sso.keycloak = config.keycloak;
	}

	// Configure defaults, unless explicitly overridden.
	if (!renutils.sso.checkSsoFunc) {
		renutils.sso.checkSsoFunc = renutils.defaultCheckSso;
	}

	if (!renutils.sso.webappLogoutFunc) {
		renutils.sso.webappLogoutFunc = renutils.defaultWebappLogout;
	}

	// Register automatic logout-listeners.
	if (renutils.sso.keycloak) {
		renutils.sso.keycloak.onAuthLogout = renutils.onKeycloakAuthLogout;
	}

	// Initialize a browser-tab (or multi-tab) persisted timestamp representing the previous polling.
	renutils.sso.prevPollSsoTime = sessionStorage.prevPollSsoTime;
	if (!renutils.sso.prevPollSsoTime) {
		sessionStorage.prevPollSsoTime = renutils.sso.prevPollSsoTime = new Date().getTime();
	}

	// Although sessionStorage is mainly intended as browser-tab-isolated, it might still be shared between tabs.
	// And because of this, we must _not_ rely on it more than necessary (i.e. at page loading). Within a page,
	// we'll only use the local and safe renutils.sso.prevPollSsoTime, and not even touch the persisted timestamp
	// (so that we won't accidentally make other tabs miss their polling). In order to still be able to avoid polling
	// once after every page navigation (which is the whole point with persisting the time stamp), we synchronize the
	// persisted value (only) on page unload.
	window.addEventListener("beforeunload", function() {
		sessionStorage.prevPollSsoTime = renutils.sso.prevPollSsoTime;
	});

	// Register a listener for updating the page-local timestamp for the latest user activity.
	var onUserInteraction = function() {
		var prevLastActivityTime = renutils.sso.lastActivityTime;
		renutils.sso.lastActivityTime = new Date().getTime();

		// If the user has been idle for a while, trigger SSO polling immediately.
		// By doing so, we can detect sessions that have timed out since the previous periodic polling.
		if (renutils.sso.lastActivityTime - prevLastActivityTime > renutils.sso.EAGER_POLL_SSO_MIN_INACTIVITY_DURATION) {
			renutils.pollSso(true);
		}
	};

	document.addEventListener("mousemove", onUserInteraction);
	document.addEventListener("touchmove", onUserInteraction);
	document.addEventListener("click", onUserInteraction);
	document.addEventListener("keypress", onUserInteraction);

	// Start a timer for SSO keep-alive & change detection.
	renutils.sso.casLoginStamp = renutils.getCookie(renutils.sso.ssoLoginStampName);
	renutils.sso.ssoTimer = setInterval(renutils.runSsoTimer, 1000);
};

renutils.runSsoTimer = function() {
	// Check if there are changes in the login stamp - i.e. the user has logged in or out in some other browser tab.
	var ssoLoginStamp2 = renutils.getCookie(renutils.sso.ssoLoginStampName);
	if (ssoLoginStamp2 != renutils.sso.casLoginStamp) {
        renutils.console.log("Detected a change in SSO login (" + ssoLoginStamp2 + " != " + renutils.sso.casLoginStamp + ")");

		renutils.sso.casLoginStamp = ssoLoginStamp2;

		// In the case of log-out, delay a bit more in order to give the server some time to process
		// the SSO single-sign-out request.
		if (renutils.sso.casLoginStamp == null) {
			renutils.delayExec("sso-auto-refresh", function() {
                renutils.console.log("Detected potential SSO logout...");
				renutils.pollSso(true);
			}, 1500);
		}
		// For possible log-ins, poll after a shorter delay (but not immediately, since especially Keycloak login might
		// take a short while to finish, during which Keycloak will still treat the user as unauthenticated).
		else {
            renutils.delayExec("sso-auto-refresh", function() {
                renutils.console.log("Detected potential SSO login...");
            	renutils.pollSso(true);
            }, 1000);
		}

		return;
	}

	// Periodically perform SSO polling.
	var time = new Date().getTime();
	if (!renutils.sso.prevPollSsoTime || time - renutils.sso.prevPollSsoTime > renutils.sso.POLL_SSO_PERIOD) {
		renutils.pollSso(false);
	}
}

renutils.pollSso = function(force) {
	// Already logged out?
	if (renutils.sso.showingLoggedOutFlag)
		return;

	// Update the time stamp.
	var time = new Date().getTime();
	var activeSinceLastPolling = time - renutils.sso.lastActivityTime < renutils.sso.POLL_SSO_PERIOD;

	renutils.sso.prevPollSsoTime = time;

	if (renutils.sso.checkSsoFunc && (force || activeSinceLastPolling)) {
		renutils.sso.checkSsoFunc();
	}
}

renutils.defaultCheckSso = function() {
	// Check if the webapp session is still alive (and keep it alive).
	if (renutils.sso.webappCheckSessionUrl) {
		renutils.checkWebappSession();
	}

	// Check if the keycloak.js object is still alive (and keep it alive).
	if (renutils.sso.keycloak && renutils.sso.keycloak.isTokenExpired(renutils.sso.POLL_SSO_PERIOD)) {
		renutils.sso.keycloak.updateToken(renutils.sso.POLL_SSO_PERIOD * 2).then(function() {
		}).catch(function(err) {
			renutils.handleKeycloakError();
		});
	}

	// Check if the SSO session is still alive.
	if (renutils.sso.casLoginUrl && renutils.sso.casLogoutUrl) {
		renutils.checkCasSession();
	}
}

renutils.checkWebappSession = function() {
	var xhr = renutils.createCORSRequest("GET", renutils.appendQueryParam(renutils.sso.webappCheckSessionUrl, "cache=" + (Math.random() * 1000000)));

	if (xhr) {
		xhr.withCredentials = true;
		xhr.noErrorHandling = true;

		xhr.onload = function () {
            if (xhr.status === 205 /* Status 205, "Reset Content" */) {
                renutils.console.log("The webapp requests page reload - most likely because the user has been logged in.");
                window.location.replace(window.location.toString());
            }
			else if (xhr.status === 401 || xhr.responseText === "NO SESSION") {
                renutils.console.log("The webapp session has timed/logged out.");
				renutils.showLoggedOut();
			}
			else if (xhr.status >= 400) {
                renutils.console.log("Webapp session checking failed... Assuming some sort of logout / timeout. Status: " + xhr.status + ", " + xhr.statusText);
				renutils.showLoggedOut();
			}
		}

		xhr.onerror = function () {
            renutils.console.log("Webapp session checking error... Unknown reason, status: " + xhr.status + ", " + xhr.statusText);
		};

		xhr.send(null);
	}
}

renutils.checkCasSession = function() {
	// Not allowed to check the CAS session?
	// Possible reasons could be:
	// - The target domain is not *.ren.no?
	// - The script wasn't registered with a CAS login / logout URL (i.e. shouldn't keep CAS alive)?
	// - The current page is actually the CAS login or logout page?
	if (!/^https?:\/\/[^\/]+\.ren\.no(:\d+)?\/.*$/.test(window.location.href) ||
		!renutils.sso.casLoginUrl || window.location.href.indexOf(renutils.sso.casLoginUrl) == 0 ||
		!renutils.sso.casLogoutUrl || window.location.href.indexOf(renutils.sso.casLogoutUrl) == 0) {
		return;
	}

	var time = new Date().getTime();
	var activeSinceLastKeepAlive = time - renutils.sso.lastActivityTime < renutils.sso.POLL_SSO_PERIOD;

	// If the user has been active in this browser tab since the last polling, then keep CAS alive
	// by requesting a new service ticket. This should prevent the SSO session from expiring.
	// If the user isn't active in _any_ browser tab, then send a request to the login page, but
	// _without_ a service. This should let us detect when CAS expires, without preventing it from expiring.
	var url = activeSinceLastKeepAlive ?
		renutils.appendQueryParam(renutils.sso.casLoginUrl, "keep-alive=true&service=" + renutils.sso.casKeepAliveServiceUrl) : renutils.sso.casLoginUrl;

	var xhr = renutils.createCORSRequest("GET", url);

	if (xhr) {
		xhr.withCredentials = true;
		xhr.noErrorHandling = true;

		xhr.onload = function() {
			if (xhr.status == 503) {
                renutils.console.log("CAS keep-alive failed... CAS is unavailable.");
			}
			else if (xhr.responseText === "NO SESSION") {
                renutils.console.log("CAS keep-alive failed... The webapp has timed out.");
				renutils.showLoggedOut();
			}
			else if (xhr.responseText.indexOf("<title>Logg inn</title>") >= 0) {
                renutils.console.log("CAS keep-alive failed... The TGT has timed out.");
				renutils.onSsoLogout();
			}
			else if (xhr.status >= 400) {
                renutils.console.log("CAS keep-alive failed... Unknown reason, status: " + xhr.status + ", " + xhr.statusText);
			}
		};

		xhr.onerror = function() {
            renutils.console.log("CAS keep-alive failed... Unknown error, status: " + xhr.status + ", " + xhr.statusText);
		};

		xhr.send(null);
	}
}

renutils.handleKeycloakError = function() {
	if (renutils.sso.keycloak) {
		if (console && console.log) console.info("Update token failed... Retrying.");

		renutils.sso.keycloak.updateToken(renutils.sso.POLL_SSO_PERIOD * 2).then(function() {
		}).catch(function(err) {
			if (console && console.log) console.info("Update token failed (" + err + "). Assuming that SSO has timed out.");
			renutils.onSsoLogout();
		});
	}
}

renutils.onKeycloakAuthLogout = function() {
	// Keycloak triggers onAuthLogout when the client token is cleared, so we must check if the Keycloak session is
	// still active.
	if (renutils.sso.keycloak) {
		renutils.handleKeycloakError();
	}
}

renutils.onSsoLogout = function() {
    renutils.console.log("SSO logout detected.");

    if (renutils.sso.keycloak) {
    	renutils.sso.keycloak.clearToken();
    }

	renutils.delayedWebappLogout();
	renutils.showLoggedOut();
}

renutils.explicitLogout = function(callback) {
    renutils.console.log("Explicit log-out requested.");

    // If a callback is provided, wrap it in a function that ensures it's only called once.
    var calledBack = false;
    var wrappedCallback = (callback == null) ? null : function() {
    	if (calledBack)
    		return;

        calledBack = true;
        callback();
	};

	renutils.clearSession();
	renutils.webappLogout(wrappedCallback);

    if (renutils.sso.keycloak) {
        renutils.sso.keycloak.clearToken();
    }

    // We cannot rely on webapp logout to call the callback (error handling, custom function etc), so
	// we schedule a fallback for the callback.
	if (wrappedCallback != null) {
        setTimeout(wrappedCallback, 300);
	}
}

renutils.delayedWebappLogout = function() {
	// Delay explicit webapp logout, since the server side logout request might fail (in Undertow with IllegalStateException
	// UT000010 about session not found, followed by some JSF exceptions) if it started before the SSO logout request has
	// finished invalidating the session. This is because the logout request would then permanently refer the old session,
	// that has become invalidated.
	renutils.delayExec("webapp-logout", function() {
		renutils.webappLogout(null);
	}, 1000);
}

renutils.webappLogout = function(callback) {
	if (renutils.sso.webappLogoutFunc) {
		renutils.sso.webappLogoutFunc(callback);
	}
	else if (callback) {
		callback();
	}
}

renutils.defaultWebappLogout = function(callback) {
	// The SSO logout will only log-out the session based on the latest ticket. If we access the webapp with
	// a new SSO ticket parameter, then SSO logout will no longer invalidate the (correct) session... Therefore,
	// we attempt to logout this session explicitly.
	if (renutils.sso.webappJsessionIdPath) {
        renutils.console.log("Deleting JSESSIONID");
		renutils.deleteCookie("JSESSIONID", renutils.sso.webappJsessionIdPath);
	}

	// Also attempt to perform an explicit client-side initiated logout. This is necessary since the JSESSIONID might be HTTP-only and
	// inaccessible from Javascript.
	if (renutils.sso.webappLogoutUrl) {
        renutils.console.log("Webapp logout, URL = '" + renutils.sso.webappLogoutUrl + "'");

		var xhr = renutils.createCORSRequest("GET", renutils.sso.webappLogoutUrl);
		if (xhr) {
			xhr.withCredentials = true;
			xhr.noErrorHandling = true;

			xhr.onload = function() {
				if (xhr.status >= 400) {
                    renutils.console.log("Webapp logout failed... Unknown reason, status: " + xhr.status + ", " + xhr.statusText);
				}

				if (callback) {
					callback();
				}
			}

			xhr.onerror = function() {
                renutils.console.log("Webapp logout error... Unknown reason, status: " + xhr.status + ", " + xhr.statusText);
			};

			xhr.send(null);
			return;
		}
	}

	if (callback) {
		callback();
	}
}

renutils.isShowingError = function(id) {
	var dlgElems = document.getElementsByClassName("renUtilsDialog.renUtilsDialog-" + id);
    return dlgElems && dlgElems.length > 0;
}

renutils.hideError = function(id) {
    renutils.removeElementByClass("renUtilsDialogBackground.renUtilsDialog-" + id);
    renutils.removeElementByClass("renUtilsDialog.renUtilsDialog-" + id);
}

renutils.showError = function(id, title, msg, closeable) {
	// Delete potential previous instances of this dialog.
    renutils.hideError(id);

    // Create and show an error dialog.

	var body = document.getElementsByTagName("body")[0];
	body.insertAdjacentHTML("beforeend",
		"<div class='renUtilsDialogBackground renUtilsDialog-" + id + "' style='position: fixed; z-index: 999999; width: 100%; height: 100%; top: 0; left: 0;" +
		"opacity: 0.3; background: #000;'></div>" +
		"<div class='renUtilsDialog renUtilsDialog-" + id + "' style='position: fixed; z-index: 999999; width: 100%; height: 70%; top: 30%;'>" +
		"<div style='max-width: 450px; min-height: 100px; top: 30%;" +
		"padding: 20px; margin: 10px auto; text-align: left; " +
		"background: #fff; border: solid 2px #a0a0a0; border-radius: 5px; " +
		"font-size: 14px;'>" +
		"<h2 style='margin-top: 0; margin-bottom: 10px; border-bottom: 1px solid #464647; " +
		"padding-bottom: 4px; font-size: 24px;'>" +
		title +
		(closeable ?
		    "<a style='float:right;' href='#' onClick='renutils.removeElementByClass(\"renUtilsDialog\"); renutils.removeElementByClass(\"renUtilsDialogBackground\"); return false;'>x</a>" : "") +
		"</h2>" +
		"<div style='margin: 0 0 10px 0;'>" +
		msg +
		"</div></div></div>");
}

renutils.showLoggedOut = function() {
	if (renutils.sso.showingLoggedOutFlag/* && renutils.isShowingError("loggedOut")*/)
		return;

	renutils.sso.showingLoggedOutFlag = true;

	renutils.clearSession();

	// Create and show a "Logged out" dialog.
	renutils.showError("loggedOut", "Utlogget",
	    "Du har blitt logget ut. Dette skjer vanligvis enten på grunn av inaktivitet " +
		"eller fordi du logget ut fra et annet vindu / fane.</p>" +
		"<p>" +
		"<a href='#' onClick='location.reload(); return false;' style='color: #69932e;'>Klikk her for å logge inn igjen.</a></p>",
		false);
}

renutils.showViewExpired = function() {
	// Create and show a "View expired" dialog.
	renutils.showError("viewExpired", "Utløpt side",
	    "<p>Siden har utløpt, og må lastes inn på nytt før du kan fortsette.</p>" +
	    "<p>" +
		//"<p style='margin: 0 0 10px 0;'>" +
		"<a href='#' onClick='location.reload(); return false;' style='color: #69932e;'>Klikk her for å oppfriske siden.</a></p>",
		false);
}

renutils.delayBuffer = {};

/**
 * Buffer and delay execution. The first invocation will start the delay. Subsequent invocations with the same
 * 'id' parameter will be dropped, until the specified function has been executed (after the delay). This is
 * a useful optimization when some event triggers some refresh or update that can be delayed.
 *
 * @param id an identifier for grouping the execution requests. Subsequent invocations to the same 'id' within
 *           the delay period will be ignored.
 * @param func the function to execute.
 * @param millisec the delay in milliseconds.
 * @returns the timer ID.
 */
renutils.delayExec = function(id, func, defaultDelay, incDelay) {
	var time = Date.now().valueOf();
	var data = renutils.delayBuffer[id];
	var f = function() {
		renutils.delayBuffer[id] = null;
		func();
	};

	if (data != null) {
		if (incDelay && data.targetTime < time + incDelay) {
			clearTimeout(data.timer);

			data.timer = setTimeout(f, incDelay);
			data.targetTime = time + incDelay;
		}

        return data.timer;
    }

	if (!defaultDelay) {
		defaultDelay = 200;
	}

	data = {
		timer: setTimeout(f, defaultDelay),
		targetTime: time + defaultDelay
	};

	renutils.delayBuffer[id] = data;

	return data.timer;
}

/**
 * A function for "eating" the enter key. This is a "useful hack" on some components that
 * trigger double submits when pressing enter. An example is ice:selectInputText. Its
 * actionListener will be triggered once on keypress and once on keyup.
 *
 * Usage: Bind e.g. the keypress event to this function using onkeypress="return renutils.eatKeyEnter(window, event);"
 */
renutils.eatKeyEnter = function(window, event) {
	return renutils.eatKey(window, event, 13 /* Enter */);
}

renutils.eatKey = function(window, event, keyCodeToEat) {
	var keyCode;

	if (window.event) {
		keyCode = event.keyCode;
	}
	else if (event.which) {
		keyCode = event.which;
	}

	if (keyCode != keyCodeToEat)
		return true;

	if (window.event) {
		window.event.cancelBubble = true;
	}
	else {
		event.stopPropagation();
	}

	return false;
}

renutils.getCustomerExternalSourceFromToken = function(token) {
	try {
		const arrayToken = token.split('.');
		if (arrayToken.length !== 3) {
			renutils.console.log('Invalid JWT token format');
			return null;
		}

		const tokenPayload = JSON.parse(atob(arrayToken[1]));
		return tokenPayload.external_source;
	} catch (error) {
		renutils.console.log('Error parsing JWT token:', error);
		return null;
	}
}
